export const nutsCodes = {
    PRAHA: {
        code: 'CZ010',
        name: 'Hlavní město Praha',
    },
    JIHOCESKY_KRAJ: {
        code: 'CZ031',
        name: 'Jihočeský',
    },
    JIHOMORAVSKY_KRAJ: {
        code: 'CZ064',
        name: 'Jihomoravský',
    },
    KARLOVARSKY_KRAJ: {
        code: 'CZ041',
        name: 'Karlovarský',
    },
    KRALOVEHRADECKY_KRAJ: {
        code: 'CZ052',
        name: 'Královéhradecký',
    },
    LIBERECKY_KRAJ: {
        code: 'CZ051',
        name: 'Liberecký',
    },
    MORAVSKOSLEZSKY_KRAJ: {
        code: 'CZ080',
        name: 'Moravskoslezský',
    },
    OLOMOUCKY_KRAJ: {
        code: 'CZ071',
        name: 'Olomoucký',
    },
    PARDUBICKY_KRAJ: {
        code: 'CZ053',
        name: 'Pardubický',
    },
    PLZENSKY_KRAJ: {
        code: 'CZ032',
        name: 'Plzeňský',
    },
    STREDOCESKY_KRAJ: {
        code: 'CZ020',
        name: 'Středočeský',
    },
    USTECKY_KRAJ: {
        code: 'CZ042',
        name: 'Ústecký',
    },
    VYSOCINA: {
        code: 'CZ063',
        name: 'Vysočina',
    },
    ZLINSKY_KRAJ: {
        code: 'CZ072',
        name: 'Zlínský',
    },
};
